import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AccountCodesComponent } from './manage-account-code.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: AccountCodesComponent, data: { title: 'Account Code List' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageAccountCodeRoutingModule {}

@NgModule({
  imports: [
    ManageAccountCodeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [AccountCodesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageAccountCodeModule {}
